export const apiConstants = {
  URLPrefix: '/dropzone',
  Login: '/login',
  SearchURLSuffix: '/action/search',
  CreateFolderURLSuffix: '/action/createfolder',
  Copy: '/action/copy',
  Move: '/action/move',
  Track: '/action/track',
  Share: '/shares',
  Logout: '/logout',
  DiskUsage: '/diskusage',
  SharedByMe: '/sharedByMe',
  SharedWithMe: '/sharedWithMe',
  ResendFileShareEmail: '/action/resendEmail',
  SharePermissionRequest: '/share-access-requests',
  approveOrRejectRequest: '/decide',
  withdrawSharePermissionRequest: '/cancel',
  resumeSharePermissionRequest: '/resume',
  Help: '/help',
  Root: '/_fv_root',
  URLToKeepSessionAlive: '/json',
  Limit: 50,
  PageNo: 1,
  SortType: 'desc',
  SortBy: 'modifiedDate',
  PaginationLabel: [
    { name: 'First;', key: 'first', label: 'double-left' },
    { name: 'Previous', key: 'previous', label: 'single-left' },
    { name: 'Numbers', key: 'numbers', label: 'number' },
    { name: 'Next', key: 'next', label: 'single-right' },
    { name: 'Last;', key: 'last', label: 'double-right' },
  ],
  FileRetentionDays: 120,
  OneGBInBytes: 1073741824,
  OneMB: 1048576,
  SessionWakeInterval: 5 * 60 * 1000,
  FeedBackURL: 'https://go/dz-beta-bug',
}
